import { cn } from '@/lib/utils';

export interface SkeletonBlockProps {
  /** Tailwind size classes, e.g. `h-32 w-full`. */
  className?: string;
  /** Rounded corner scale token (`lg` cards, `md` controls, `sm` badges). */
  rounded?: 'sm' | 'md' | 'lg';
}

const ROUNDED_CLASSES = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
} as const;

/**
 * Card/control placeholder (design §15.3). Tailwind's core `animate-pulse` on
 * `bg-muted` instead of a shadcn `skeleton` file — the one documented deviation
 * in the mirrored primitive set (H1). Always `aria-hidden`: skeletons are
 * decorative, the loading label lives on `LoadingRows`.
 */
export function SkeletonBlock({ className, rounded = 'lg' }: SkeletonBlockProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'animate-pulse bg-muted motion-reduce:animate-none',
        ROUNDED_CLASSES[rounded],
        className,
      )}
    />
  );
}
